import React, { useState, useEffect } from "react";
import SalespersonSidebar from "./SalespersonSidebar";
import './classes/AddNewProduct.css';
import Loading from './Loading';
import { configData } from "../config";
import { Helmet } from 'react-helmet';
import Editor from 'react-simple-wysiwyg';

const AddNewProduct = () => {
  
  const [isLoading, setIsLoading] = useState(true);
  const app_url = configData.APP_URL; 
    // === Product Type to Fields Map ===
  const productTypeFields = {
    0: ["product_name", "product_sku", "product_price", "product_price1", "product_price2", "product_status", "disclaimer"],
    1: ["product_name", "product_sku", "product_price", "product_price1", "product_price2", "product_status", "disclaimer"],
    2: ["product_name", "product_sku", "product_price", "product_status", "disclaimer"],
    3: ["product_name", "product_sku", "product_price", "product_status", "disclaimer"],
    4: ["product_price", "relate_misc", "product_status", "disclaimer_editor"],
    5: ["product_name", "product_sku", "product_price", "product_status", "disclaimer"],
    6: ["product_name", "product_sku", "product_price", "product_status", "disclaimer"],
    7: ["product_name", "product_sku", "product_price",  "product_status", "disclaimer"],
    8: ["product_name", "product_sku", "package_sku", "relate_package", "product_status", "disclaimer"],
    9: ["product_name", "product_sku", "product_price", "files", "relate_categories", "weight", "size", "sizes", "size_chart", "product_status", "product_description"],
  };
  const [miscOptions, setMiscOptions] = useState({})
  const [packageOptions, setpackageOptions] = useState({})
  const [relatepackage, setrelatepackage] = useState({}) 
   const [categories, setcategories] = useState({})
   const [errors, setErrors] = useState([]);   
  const[success,setSuccess] = useState('');
  const [fieldErrors, setFieldErrors] = useState({});
 const [uploadedFiles, setUploadedFiles] = useState([]);

 const [errorMessage, setErrorMessage] = useState('');

  const initialForm = {
    product_type:"0",
    product_name:'',
    product_sku:'',
    package_sku:[],
    relate_package:'',
    product_price:'',
    product_price1:'',
    product_price2:'',
    relate_categories:'',
    files:[],
    weight:'',
    size: false,
    sizes: [{ name: "", price: "" }],
    size_chart: "",
    product_status:1,
    product_description:'',
    relate_misc:'',
    disclaimer_editor:'',
    disclaimer_content:'',
    button_name:'Save Product',
};  

const defaultTable = `
  <table border="1" style="width:100%; border-collapse:collapse; text-align:center; font-size: 14px">
    
	<tbody>
		<tr>
			<th>Size</th>
			<th>Chest(in inches)</th>
			<th>Waist(in inches)</th>
		</tr>
		<tr>
			<td>Small</td>
			<td>34-36&quot;</td>
			<td>28-30&quot;</td>
		</tr>
		<tr>
			<td>Medium</td>
			<td>38-40&quot;</td>
			<td>32-34&quot;</td>
		</tr>
		<tr>
			<td>Large</td>
			<td>42-44&quot;</td>
			<td>36-38&quot;</td>
		</tr>
		<tr>
			<td>Extra Large</td>
			<td>46-48&quot;</td>
			<td>40-42&quot;</td>
		</tr>
	</tbody>


  </table>
`;

     const [formData, setFormData] = useState(initialForm);
    
const validateForm = () => {
  const newFieldErrors = {};
  const newMessages = [];

  // Define custom labels for form fields
  const fieldLabels = {
    
    product_name: "Product Name",
    product_sku: "Product SKU",
    product_price: "Product Price",
    product_price1: "Product Price 1",
    product_price2: "Product Price 2",
    relate_misc: "Miscellaneous Product",
    relate_categories: "Product Categories",
    files: "Product Image(s)",
    weight: "Product Weight", 
    product_status: "Product Status",
    package_sku: "Package product",
    relate_package: "Relate package",
  };

  const currentFields = productTypeFields[formData.product_type] || [];
  if(formData.product_type == 0) {
    const msg = `Product Type is required.`;
     
          newMessages.push(msg);
  }
 
  const priceRegex = /^[0-9.,]+$/;

  currentFields.forEach((field) => {
    const value = formData[field];

    
    const fieldLabel = fieldLabels[field] || field.replace(/_/g, " ").replace(/\b\w/g, l => l.toUpperCase());

    switch (field) {
      case "product_price":
        if (!value || isNaN(value)) {
          const msg = `${fieldLabel} is required.`;
          newFieldErrors[field] = msg;
          newMessages.push(msg);
        }
        break;

        // --- PRODUCT PRICE1 & PRICE2 (allow commas and dots) ---
      case "product_price1":
      case "product_price2":
        if (!value || value.trim() === "") {
          const msg = `${fieldLabel} is required.`;
          newFieldErrors[field] = msg;
          newMessages.push(msg);
        } else if (!priceRegex.test(value)) {
          const msg = `${fieldLabel} must contain only numbers.`;
          newFieldErrors[field] = msg;
          newMessages.push(msg);
        }
        break;

      // case "product_price1":
      // case "product_price2":
      // case "product_name":
      // case "product_sku":
      // case "relate_misc":
      //   if (!value || (typeof value === "string" && value.trim() === "")) {
      //     const msg = `${fieldLabel} is required.`;
      //     newFieldErrors[field] = msg;
      //     newMessages.push(msg);
      //   }
      //   break;
  // case "product_price1":
  // case "product_price2":
  case "product_name":
  case "product_sku":
  case "relate_misc":
  case "relate_categories":
  case "package_sku":
  case "relate_package":
  // case "files":
  case "weight":
    if (
      !value ||
      (typeof value === "string" && value.trim() === "") ||
      (field === "package_sku" && (!value || value.length === 0))
      // (field === "files" && (!value || value.length === 0))
    ) {
      const msg = `${fieldLabel} is required.`;
      newFieldErrors[field] = msg;
      newMessages.push(msg);
    }
    break;
    case "files": {
      if (field === "files" && uploadedFiles.length === 0 && errorMessage === "" ) {
      const msg = `${fieldLabel} is required.`;
      newFieldErrors[field] = msg;
      newMessages.push(msg);
      }
      break;
    }
       case "sizes":
        formData.sizes.forEach((size, index) => {
   if (size.price && size.price.trim() !== "") {
  if (!priceRegex.test(size.price)) {
    const msg = `Size #${index + 1} Price must contain only numbers.`;
    newFieldErrors[`sizes.${index}.price`] = msg;
    newMessages.push(msg);
  }
}
    });
        break;
      case "product_status":
        if (!value) {
          const msg = `${fieldLabel} is required.`;
          newFieldErrors[field] = msg;
          newMessages.push(msg);
        }
        break;
   
        
      default:
        break;
    }
  });

  setFieldErrors(newFieldErrors);
  setErrors(newMessages);

  return newMessages.length === 0;
};



       // === Dynamic field renderer ===
const renderField = (field) => {
  switch (field) {
    case "product_name":
      return (
        <div className="form-group product_name_group" key={field}>
          <label>
            Product Name <span className="form-required">*</span>
          </label>
          <input
            className="input-large"
            type="text"
            name="product_name"
            id="product_name"
            value={formData.product_name}
            onChange={handleChange}
           
          />
        </div>
      );

    case "product_sku":
      return (
        <div className="form-group product_sku_group" key={field}>
          <label>
            Product SKU <span className="form-required">*</span>
          </label>
          <input
            className="input-medium"
            type="text"
            name="product_sku"
            id="product_sku"
            value={formData.product_sku}
            onChange={handleChange}
            
          />
        </div>
      );

    case "package_sku":
      return (
        <div className="form-group package_sku" key={field}>
          <label htmlFor="package_sku">Package product</label>
          <select
            id="package_sku"
            name="package_sku"
            multiple
            // required
            value={formData.package_sku}
            onChange={handleChange}
          >
            {packageOptions.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        </div>
      );

    case "relate_package":
      return (
        <div className="form-group relate_package" key={field}>
          <label htmlFor="relate_package">Relate package</label>
          <select
            id="relate_package"
            name="relate_package"
            // required
            value={formData.relate_package}
            onChange={handleChange}
          >
            <option value="">-Select-</option>
            {relatepackage.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        </div>
      );

    case "product_price":
      return (
        <div className="form-group product_main_price" key={field}>
          <label>
            Product Price <span className="form-required">*</span>
          </label>
          <input
            className="input-medium"
            type="number"
            step="any"
            name="product_price"
            id="product_price"
            value={formData.product_price}
            onChange={handleChange}
          
          />{" "}
          USD
        </div>
      );

   
case "product_price1":
  return (
    <div className="form-group course_product_text" key={field}>
      <label>
        Product Price1 <span className="form-required">*</span>
      </label>
      <input
        className="input-medium"
        type="text"
        name="product_price1"
        id="product_price1"
        value={formData.product_price1}
        onChange={handleChange}
       
      />{" "}
      USD
    </div>
  );

case "product_price2":
  return (
    <div className="form-group course_product_text" key={field}>
      <label>
        Product Price2 <span className="form-required">*</span>
      </label>
      <input
        className="input-medium"
        type="text"
        name="product_price2"
        id="product_price2"
        value={formData.product_price2}
        onChange={handleChange}
      
      />{" "}
      USD
    </div>
  );

    case "relate_categories":
      return (
        <div className="form-group" key={field}>
          <label htmlFor="relate_categories">Select Categories</label>
          <select
            id="relate_categories"
            name="relate_categories"
            value={formData.relate_categories}
            onChange={handleChange}
          >
            <option value="">-Select-</option>
            {categories.map((cat) => (
              <option key={cat.value} value={cat.value}>
                {cat.label}
              </option>
            ))}
          </select>
        </div>
      );

    case "files":
      return (
        <div className="form-group" key={field}>
          <label htmlFor="files">Product Image(s)</label>
          <input
            type="file"
            name="files"
            id="files"
            multiple
            onChange={handleChange}
          />
          <p className="help-text" style={{marginBottom: "0px"}}>
            To add more than one image, hold down ctrl and select as many as you
            want
          </p>
          {errorMessage && (
            <div style={{color: "red"}}>
              {errorMessage}
            </div>
          )}
        </div>
      );

    case "weight":
      return (
        <div className="form-group" key={field}>
          <label>Product Weight</label>
          <input
            className="input-medium"
            type="number"
            id="weight"
            name="weight"
            step="any"
            value={formData.weight}
            onChange={handleChange}
        
          />{" "}
          lbs
        </div>
      );

    case "size":
      return (
        <div className="form-group" key={field}>
          <input
            type="checkbox"
            name="size"
            checked={formData.size}
            onChange={handleChange}
          />{" "}
          Enable Size
        </div>
      );

    case "sizes":
      return (
        formData.size && (
          <div className="product_attributes" key={field}>
            <a
              href="#"
              className="add-size-link"
              onClick={(e) => {
                e.preventDefault();
                addSizeAttribute();
              }}
            >
              + Add Size Attribute
            </a>
            <table>
              <tbody>
                {formData.sizes.map((size, index) => (
                  <tr key={index}>
                    <td>
                      Size:
                      <input
                        type="text"
                        value={size.name}
                        onChange={(e) =>
                          handleSizeChange(index, "name", e.target.value)
                        }
                      />
                    </td>
                    <td>
                      Price:
                      <input
                        type="text"
                        value={size.price}
                        onChange={(e) =>
                          handleSizeChange(index, "price", e.target.value)
                        }
                      />
                    </td>
                    <td>
                      <a
                        href="#"
                        className="remove-size-link"
                        onClick={(e) => {
                          e.preventDefault();
                          removeSizeAttribute(index);
                        }}
                      >
                        <img
                          src="/basic/web/images/delete_icon.png"
                          alt="Remove"
                          className="remove-icon"
                        />
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <div className="edit-profile-row">
              <label>Size Chart</label>
              <Editor
                value={formData.size_chart || defaultTable}
                onChange={(e) =>
                  onEditorChange("size_chart", e.target.value)
                }
              />
            </div>
          </div>
        )
      );

    case "relate_misc":
      return (
        <div className="miscellaneous" key={field}>
          <label>
            Relate Miscellaneous Product <span className="form-required">*</span>
          </label>
          <select
            name="relate_misc"
            id="relate_misc"
            // required
            value={formData.relate_misc}
            onChange={handleChange}
          >
            <option value="">-Select-</option>
            {miscOptions.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        </div>
      );

    case "product_status":
      return (
        <div className="form-group" key={field}>
          <label>
            Product Status <span className="form-required">*</span>
          </label>
          <select
            id="product_status"
            name="product_status"
            value={formData.product_status}
            onChange={handleChange}
          >
            <option value="1">Active</option>
            <option value="2">Disabled</option>
          </select>
        </div>
      );

    case "disclaimer_editor":
      return (
        <div className="form-group" key={field}>
          <label>Note</label>
          <textarea
            id="disclaimer_content"
            name="disclaimer_content"
            className="input-textarea"
            value={formData.disclaimer_content} 
            onChange={handleChange}
          />
        </div>
      );

    case "product_description":
      return (
        <div className="edit-profile-row" key={field}>
          <label>Product Description</label>
          <Editor
            value={formData.product_description}
            onChange={(e) =>
              onEditorChange("product_description", e.target.value)
            }
          />
        </div>
      );

    case "disclaimer":
      return (
        <div className="edit-profile-row" key={field}>
          <label>Disclaimer</label>
          <Editor
            value={formData.disclaimer_content}
            onChange={(e) =>
              onEditorChange("disclaimer_content", e.target.value)
            }
          />
        </div>
      );

    default:
      return null;
  }
};

    const validTypes = [
        'image/png',
        'image/jpeg',
        'image/jpg',
        'image/gif'
    ];

    const maxSize = 128 * 1024 * 1024;
 
  const handleChange = (e) => {
  const { name, type, checked, value, files, multiple, selectedOptions } = e.target;

  let newValue;
  if(name == 'product_type') {
    setFormData(initialForm);
  }
  if (type === "file") {
    newValue = Array.from(files);

        const validFiles = [];
        const invalidFiles = [];

        newValue.forEach(file => {
            const isValidType = validTypes.includes(file.type);
            const isValidSize = file.size <= maxSize;

            if (isValidType && isValidSize) {
            validFiles.push(file);
            } else {
            invalidFiles.push(file);
            }
        });

        if (invalidFiles.length > 0) {
            const names = invalidFiles.map(f => f.name).join(', ');
            setErrorMessage(
            <>
                <div>The selected file{invalidFiles.length > 1 ? 's' : ''} <i>{names}</i> cannot be uploaded.</div>
                <div>Only files with the following extensions are allowed: <i>png, jpg, jpeg, gif</i>.</div>
            </>
            );
            setUploadedFiles(""); 
        } else {
            setErrorMessage('');
            setUploadedFiles(newValue); 
        }
  } else if (type === "checkbox") {
    newValue = checked;
  } else if (multiple) {
    //  handles multi-select
    newValue = Array.from(selectedOptions, (opt) => opt.value);
  } else {
    newValue = value;
  }

  // setFormData((prev) => ({
  //   ...prev,
  //   [name]: newValue,
  // }));
  setFormData((prev) => {
    if (name === "product_type") {
      setErrorMessage("");
      setUploadedFiles(""); 
    }

    return {
      ...prev,
      [name]: newValue,
    };
  });
};

const cleanHtmlOutput = (html) => {
  if (!html) return "";

  // Remove empty p/div/h1-h6 that only contain <br> or spaces
  let cleaned = html.replace(/<\s*(p|div|h[1-6]|th|td)[^>]*>\s*(<br\s*\/?>|&nbsp;|\s)*<\/\1\s*>/gi, "");

  // Remove stray <br>
  cleaned = cleaned.replace(/<br\s*\/?>/gi, "");

  // Check if anything meaningful is left
  const textOnly = cleaned.replace(/&nbsp;|\s|<[^>]*>/g, "").trim();

  return textOnly.length === 0 ? "" : cleaned.trim();
};


    const onEditorChange = (field, value) => {
      setFormData(prev => ({ ...prev, [field]: value }));
    };
      
useEffect(() => {
    Promise.all([
      retrievemisclist(),
      retrievepackagelist(),
      retrieverelatepackagelist(),
      retrievecategorylist()
     ])
     .then(() => {
     
      setIsLoading(false);
    })
}, []);
 async function retrievemisclist() {
    
       
            const response = await fetch(
                 app_url+'smwwcommerceproduct/getmisclist',
                {
                    method: "GET",
  
                    headers: {
                    'Content-Type': 'application/json',
                    },
                }
            )           
            const responsedata = await response.json();
            if(responsedata.data.msg === "Success") {
                setMiscOptions(responsedata.data.result);
            }
       
    }
    async function retrievepackagelist() {
    
       
            const response = await fetch(
                 app_url+'smwwcommerceproduct/getpackagelist',
                {
                    method: "GET",
  
                    headers: {
                    'Content-Type': 'application/json',
                    },
                }
            )           
            const responsedata = await response.json();
            if(responsedata.data.msg === "Success") {
                setpackageOptions(responsedata.data.result);
            }
       
    }
    async function retrievecategorylist() {
    
       
            const response = await fetch(
                 app_url+'smwwcommerceproduct/getapparelcategorylist',
                {
                    method: "GET",
  
                    headers: {
                    'Content-Type': 'application/json',
                    },
                }
            )           
            const responsedata = await response.json();
            if(responsedata.data.msg === "Success") {
                setcategories(responsedata.data.result);
            }
       
    }
     async function retrieverelatepackagelist() {
    
       
            const response = await fetch(
                 app_url+'smwwcommerceproduct/getrelatepackagelist',
                {
                    method: "GET",
  
                    headers: {
                    'Content-Type': 'application/json',
                    },
                }
            )           
            const responsedata = await response.json();
            if(responsedata.data.msg === "Success") {
                setrelatepackage(responsedata.data.result);
            }
       
    }
           // Handle size attribute change
  const handleSizeChange = (index, field, value) => {
    const updatedSizes = [...formData.sizes];
    updatedSizes[index][field] = value;
    setFormData((prev) => ({ ...prev, sizes: updatedSizes }));
  };

  // Add new size row
  const addSizeAttribute = () => {
    setFormData((prev) => ({
      ...prev,
      sizes: [...prev.sizes, { name: "", price: "" }],
    }));
  };

  // Remove size row
  const removeSizeAttribute = (index) => {
    setFormData((prev) => ({
      ...prev,
      sizes: prev.sizes.filter((_, i) => i !== index),
    }));
  };
   
  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors([]);
    setSuccess('');

    const isValid = validateForm();
    if (!isValid) {
      window.scrollTo(0, 0);
      return;
    }

    if (errorMessage) {
      window.scrollTo(0, 0);
      return;
    }

    const finalSizeChart = cleanHtmlOutput(formData.size_chart);

          const filteredSizes = formData.sizes.filter(
            (size) =>
            size &&
            Object.values(size).some(
                (val) => val !== "" && val !== null && val !== undefined
            )
        );

    const updatedFormData = {
      ...formData,
      size_chart: finalSizeChart,
      sizes: filteredSizes
    };

    setFormData(prev => ({
      ...prev,
      button_name: "Saving...",
      isSubmitting: true
    }));

    const postData = new FormData();
    for (let i = 0; i < uploadedFiles.length; i++) {
  postData.append('apparelfiles[]', uploadedFiles[i]);
}
    postData.append('formData', JSON.stringify(updatedFormData));

    try {
      const response = await fetch(app_url + 'smwwcommerceproduct/addproductdetails', {
        method: 'POST',
        body: postData  
      });
      const responsedata = await response.json();

      if (responsedata.data.msg === "Success") {
        setErrors([]);
        setSuccess(responsedata.data.result);
        setFormData(prev => ({
          ...initialForm,
          button_name: "Save Product",
          isSubmitting: false
        }));
        window.scrollTo(0, 0);
      } else if (responsedata.data.msg === "Error") {
        setErrors(responsedata.data.result);
        setSuccess('');
        setFormData(prev => ({
          ...prev,
          button_name: "Save Product",
          isSubmitting: false
        }));
        window.scrollTo(0, 0);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setFormData(prev => ({
        ...prev,
        button_name: "Save Product",
        isSubmitting: false
      }));
    }
  };

  return (
     <>
            {isLoading ? (
                <Loading />
            ) : ( 
    <div id="main">
      <div className="left"></div>

      <div className="center left-center">
        <h1>Create Product</h1>
        <Helmet><title>Create Product</title></Helmet>
       <div className="add-new-product-container">         
      {errors.length > 0 && (
          <div className="set-message-error" style={{ background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 10px no-repeat`}}>
           {errors.map((item, index) => {
           return <>{item}<br /></>
          
        })}  
          </div>
        )}
        {success && (
          <div className="set-message-done">
            <span className="cart-message-icon message-icon"><i className="fa fa-check-circle"></i></span><span dangerouslySetInnerHTML={{__html: success}}></span>
          </div>
          
       
        )}
   <form onSubmit={handleSubmit}>
               <label>
      Product Type <span className="form-required">*</span>
    </label>
<select
  name="product_type"
  value={formData.product_type}
  onChange={handleChange}
>
  <option value="0">-Select-</option>
  <option value="1">Course</option>
  <option value="2">Agent Initiation</option>
  <option value="3">Scout Initiation</option>
  <option value="4">Miscellaneous</option>
  <option value="5">Reenroll</option>
  <option value="6">Renewal</option>
  <option value="7">Conference</option>
  <option value="8">Package</option>
  <option value="9">Apparel</option>
</select>



              {/* Fields based on product type */}
              {formData.product_type &&
                productTypeFields[formData.product_type]?.map((field) => renderField(field))}

            <button
            type="submit"
            disabled={formData.isSubmitting}
            className="form-submit"
          >
            {formData.button_name || "Save Product"}
          </button>
            </form>
</div>

      </div>

      <div className="right">
        <SalespersonSidebar />
      </div>
    </div>
         )}
        </>
  );
};

export default AddNewProduct;